import React from 'react';
import { Switch } from 'react-router-dom';
import AppRoot from '../../templates/AppRoot';
import RedefinirSenha from '../../applets/publico/redefinir-senha';
import ConfirmarCadastro from '../../applets/publico/RegistrationConfirmation';
import ConfirmarTrocaEmail from '../../applets/publico/confirmacao-troca-email';
import BoletoDownload from '../../views/p/boletos/download/@id';
import ConfirmarEmail from '../../views/p/confirmar/email/@cid';
import Participate from '../../views/p/participe/@organization';
import FakeChatbot from '../../views/p/cadastre-se';
import Erro404 from '../../applets/error/Page404';

import ConfirmarTrocaEmailView from '../../views/p/redefinir_email/@cid';
import RedefinirSenhaView from '../../views/p/senha/redefinir/@cid';

function Public() {
  return (
    <AppRoot isPublic>
      <Switch>
        {ConfirmarTrocaEmailView}
        {ConfirmarTrocaEmail}
        {RedefinirSenhaView}
        {ConfirmarCadastro}
        {BoletoDownload}
        {RedefinirSenha}
        {ConfirmarEmail}
        {Participate}
        {FakeChatbot}
        {Erro404}
      </Switch>
    </AppRoot>
  );
}

export default Public;
